import { render, staticRenderFns } from "./customerApproval.vue?vue&type=template&id=b6e550d0&scoped=true"
import script from "./customerApproval.vue?vue&type=script&lang=js"
export * from "./customerApproval.vue?vue&type=script&lang=js"
import style0 from "./customerApproval.vue?vue&type=style&index=0&id=b6e550d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e550d0",
  null
  
)

export default component.exports